var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.744 7.088v5.833c0 .341.391.542.666.333l3.892-2.916a.414.414 0 0 0 0-.667L9.41 6.754a.416.416 0 0 0-.666.334Zm.833-4.392c0-.533-.492-.942-1.008-.825a8.344 8.344 0 0 0-2.6 1.083.838.838 0 0 0-.134 1.292c.267.267.692.333 1.009.133a6.501 6.501 0 0 1 2.116-.875c.367-.083.617-.425.617-.808ZM4.66 5.429c-.383-.375-1.008-.316-1.291.134a8.343 8.343 0 0 0-1.084 2.6.832.832 0 0 0 .817 1.008c.375 0 .725-.25.8-.617a6.642 6.642 0 0 1 .875-2.108.808.808 0 0 0-.117-1.017Zm-1.558 5.409c-.533 0-.942.491-.825 1.008a8.428 8.428 0 0 0 1.083 2.6.833.833 0 0 0 1.292.133c.267-.267.333-.692.125-1.008a6.383 6.383 0 0 1-.875-2.108c-.075-.375-.417-.625-.8-.625Zm2.867 6.208c.791.5 1.666.867 2.6 1.083a.836.836 0 0 0 1.008-.817c0-.375-.25-.725-.617-.8a6.64 6.64 0 0 1-2.108-.875.81.81 0 0 0-1.008.134.81.81 0 0 0 .125 1.275Zm12.774-7.042c0 3.942-2.75 7.258-6.441 8.117-.517.125-1.017-.284-1.017-.817a.83.83 0 0 1 .625-.808c2.958-.683 5.167-3.333 5.167-6.492 0-3.158-2.209-5.808-5.167-6.491a.824.824 0 0 1-.625-.809c0-.533.5-.941 1.017-.816 3.691.858 6.442 4.175 6.442 8.116Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStories);
export default __webpack_public_path__ + "static/media/stories.fdc33de95fa85a8a5c54073b136b05ab.svg";
export { ForwardRef as ReactComponent };